import "./index.0.css";
import { INJECT_UICORE_BUS } from "../../../../lib/utils/consts";
const __script_base__ = {
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    }
  },
  computed: {
    text() {
      var _this$uc;
      const isDesignMode = (_this$uc = this.uc) === null || _this$uc === void 0 ? void 0 : _this$uc.isDesignMode;
      const {
        dataName
      } = this;
      return isDesignMode ? `点击设置 ${dataName} 的组件` : '未配置组件';
    }
  },
  props: {
    dataPath: String,
    dataName: String
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "w-formUnsettledEditor"
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/FormUnsettledEditor/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);